export const CalculateTax = (book, days) => {
  let totalTaxRoomCat = 0;
  let totalTaxRoomCatNoDiscount = 0;
  const taxDetails = [];
  

  const taxableAmtNoDiscount = book.roomCost * book.qty * days; ;

  for (const taxLevy of book.taxLevies) {
    if (
      taxLevy.taxApplicable === "fd" ||
      (taxLevy.taxApplicable === "fb" && book.breakfastType === "notFree")
    ) {
      if (taxLevy.taxType === "flatAmount") {
        const flatAmountTax = taxLevy.flatAmount * book.qty * days;
        totalTaxRoomCat += flatAmountTax;
        
        taxDetails.push({
          taxLabel: taxLevy.taxLabel,
          taxAmount: flatAmountTax,
          levyId: taxLevy.levyId,
          hotelId: taxLevy.hotelId,
          taxCategory: taxLevy.taxCategory,
          flatAmount: taxLevy.flatAmount,
          taxPercentage: taxLevy.taxPercentage,
        });
        
      } else if (taxLevy.taxType === "percentage") {
        const percentageTax = (taxLevy.taxPercentage / 100) * taxableAmtNoDiscount;
        totalTaxRoomCat += percentageTax;
        // totalTaxRoomCatNoDiscount += percentageTax;
        

        taxDetails.push({
          taxLabel: taxLevy.taxLabel,
          taxAmount: percentageTax,
          levyId: taxLevy.levyId,
          hotelId: taxLevy.hotelId,
          taxCategory: taxLevy.taxCategory,
          flatAmount: taxLevy.flatAmount,
          taxPercentage: taxLevy.taxPercentage,
        });
        
      }
    }
  }

  return {
    totalTaxRoomCat,
    taxDetails,
    // totalTaxRoomCatNoDiscount,
    
  };
}